/**
 *  Arquivo responsável por importa e exportar 
 *      todos os arquivos que de rotas de store do módulo
 */
export { default as store } from './store/index'